import { addCard } from "../../../../Redux/Profile/ProfileActions";
import { AppDispatch, RootState } from "../../../../Redux/store";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../../Common/Loading/Loading";
import validator from "../../../../Util/validator";
import Modal from "../../../Common/Modal/Modal";
import styles from "./AddCardModal.module.scss";
import { useNavigate } from "react-router";
import React, { useState } from "react";

interface Props {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

function AddCardModal(props: Props) {
  const { isOpen, setIsOpen } = props;
  const dispatch = useDispatch<AppDispatch>();
  const { addCardLoading } = useSelector((state: RootState) => state.profile);
  const navigate = useNavigate();
  const [cardNumber, setCardNumber] = useState<string>("");
  const [cardHolderName, setCardHolderName] = useState<string>("");
  const [expiry, setExpiry] = useState<string>("");
  const [cvv, setCvv] = useState<string>("");
  const [errors, setErrors] = useState<{
    cardNumber: string;
    cardHolderName: string;
    expiry: string;
    cvv: string;
  }>({
    cardNumber: "",
    cardHolderName: "",
    expiry: "",
    cvv: "",
  });
  const addCardHandler = () => {
    if (!addCardLoading) {
      const { errors: fieldErrors, isValid } = validator([
        {
          key: "cardNumber",
          type: "text",
          value: cardNumber,
        },
        {
          key: "cardHolderName",
          type: "text",
          value: cardHolderName,
        },
        {
          key: "expiry",
          type: "text",
          value: expiry,
        },
        {
          key: "cvv",
          type: "text",
          value: cvv,
        },
      ]);
      setErrors({ ...errors, ...fieldErrors });
      if (isValid) {
        const cleanupHandler = () => {
          setIsOpen(false);
          setCardNumber("");
          setCardHolderName("");
          setExpiry("");
          setCvv("");
        };
        dispatch(
          addCard({
            cardNumber: cardNumber.replace(/\s/g, ""),
            cardName: cardHolderName,
            expiry: expiry.replace(/\//g, ""),
            cvv: cvv,
            cleanupHandler,
            navigate: navigate,
          }),
        );
      }
    }
  };

  return (
    <Modal isOpen={isOpen} setIsOpen={setIsOpen} showCloseIcon={false}>
      <div className={styles.mainContainer}>
        <div className={styles.stepFiveContentWrapper}>
          <div className={styles.headingContainer}>
            <p className={styles.label}>Add New Card</p>
          </div>
          <div className={styles.modalBodyContent}>
            <div className={styles.inputContainer}>
              <p className={styles.label}>Card Holder Name</p>
              <input
                className={styles.input}
                type="text"
                value={cardHolderName}
                onChange={(e) => setCardHolderName(e.target.value)}
              />
              <p className={styles.error}>{errors.cardNumber}</p>
            </div>
            <div className={styles.inputContainer}>
              <p className={styles.label}>Card Number</p>
              <input
                className={styles.input}
                type="text"
                value={cardNumber}
                maxLength={19}
                onChange={(e) => {
                  let val = e.target.value.replace(/\D/g, "");
                  val = val.match(/.{1,4}/g)?.join(" ") || "";
                  setCardNumber(val);
                }}
              />
              <p className={styles.error}>{errors.cardNumber}</p>
            </div>
            <div className={styles.doubleInputContainer}>
              <div className={styles.inputContainer}>
                <p className={styles.label}>Expiration Date</p>
                <input
                  className={styles.input}
                  type="text"
                  value={expiry}
                  placeholder="MM/YY"
                  maxLength={5}
                  onChange={(e) => {
                    let val = e.target.value;
                    val = val.replace(/[^\d\\/]/g, "");
                    val = val.replace(/\//g, "");
                    if (val.length > 2)
                      val = val.slice(0, 2) + "/" + val.slice(2, 4);
                    setExpiry(val);
                  }}
                />
                <p className={styles.error}>{errors.expiry}</p>
              </div>
              <div className={styles.inputContainer}>
                <p className={styles.label}>CVV</p>
                <input
                  className={styles.input}
                  type="text"
                  value={cvv}
                  placeholder="CVV"
                  onChange={(e) => setCvv(e.target.value)}
                />
                <p className={styles.error}>{errors.cvv}</p>
              </div>
            </div>
          </div>
          {addCardLoading && <Loading />}
          <div className={styles.buttonsContainer}>
            <button className={styles.addButton} onClick={addCardHandler}>
              Add Card
            </button>
            <button
              className={styles.CancelButton}
              onClick={() => setIsOpen(false)}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default AddCardModal;
